import actionTypes from '../actionTypes';


export function changeLanguage(lang) {
    return {
        type: actionTypes.LANGUAGE_CHANGE,
        value: lang,
    };
}

export function soundToggle() {
  return {
    type: actionTypes.SOUND_TOGGLE
  };
}

